const size={mobile:'1024px',// 1024px
// Ab hier bekommt die Patienten-Tableiste ihre großzügigen Abstände. 7 Tabs
// sind dann ~1138px breit, die Inhaltsfläche ist Viewport minus 144px Sidebar
// minus 2x27px main-Padding. Rein passen würde es schon ab ~1340px — der Wert
// liegt bewusst höher, damit die große Variante nicht auf Kante steht.
wide:'1400px'};export const device={mobile:"(max-width: ".concat(size.mobile,")"),desktop:"(min-width: ".concat(size.mobile,")"),wide:"(min-width: ".concat(size.wide,")")};